<ng-template #content><ng-content></ng-content><span *ngIf="hasDirectText"></span></ng-template>
<ng-template [ngIf]="!link && !(routerLink===undefined || routerLink===null)">
    <a class='b-workbench-commands__link' [routerLink]="routerLink"
        (click)="wSelected.emit($event)"><ng-container *ngTemplateOutlet="content"></ng-container></a>
</ng-template>
<ng-template [ngIf]="link">
    <a class='b-workbench-commands__link' [href]="link" (click)="wSelected.emit($event)"><ng-container *ngTemplateOutlet="content"></ng-container></a>
</ng-template>
<ng-template [ngIf]="!link && (routerLink===undefined || routerLink===null) ">
    <a class='b-workbench-commands__link' (click)="wSelected.emit($event)"><ng-container *ngTemplateOutlet="content"></ng-container></a>
</ng-template>
<span class="b-pointer__arrow" *ngIf="pointer"></span>

<!-- Dropdown from facet: little dance to ensure we create dropdown only if we have injected a facet with content -->
<ng-template #a><ng-content select="f-facet[name=dropdown],[facet-dropdown]" description="generates a dropdown from included content"></ng-content></ng-template>
<template #d><ng-container *ngTemplateOutlet="a"></ng-container></template>
<!--  injected content is first in template, then move to dropdown; if any content we use the dropdown component -->
<w-dropdown #dd [wToggle]="wSelected" 
    *ngIf="(d.content.childElementCount + (dropdown?.el?.childElementCount ?? 0) )> 0">
    <ng-container *ngTemplateOutlet="a"></ng-container>
</w-dropdown>
<!-- OR display dropdown if explicitly included -->
<ng-content select="w-dropdown,[facet-w-dropdown]" description="w-dropdown component if present"></ng-content>